<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="false"
    row-key="key"
    size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Employee'">
        <div class="d-flex flex-column">
          <span class="fw-semibold">{{ record.employee_name }}</span>
          <span class="fs-12 text-muted">
            ID: {{ record.employee_id }} | {{ record.department || "-" }} /
            {{ record.designation || "-" }}
          </span>
        </div>
      </template>

      <template v-else-if="moneyColumns.includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
});

const columns = [
  {
    title: "Employee",
    key: "Employee",
    dataIndex: "employee_name",
    sorter: (a, b) =>
      (a.employee_name || "").localeCompare(b.employee_name || ""),
  },
  {
    title: "KRA PIN",
    key: "KRA",
    dataIndex: "kra_pin",
  },
  {
    title: "Gross Pay",
    key: "Gross",
    dataIndex: "gross_salary",
    sorter: (a, b) => (a.gross_salary || 0) - (b.gross_salary || 0),
  },
  {
    title: "Taxable Pay",
    key: "Taxable",
    dataIndex: "taxable_income",
    sorter: (a, b) => (a.taxable_income || 0) - (b.taxable_income || 0),
  },
  {
    title: "Tax Charged",
    key: "TaxCharged",
    dataIndex: "income_tax",
    sorter: (a, b) => (a.income_tax || 0) - (b.income_tax || 0),
  },
  {
    title: "Personal Relief",
    key: "PersonalRelief",
    dataIndex: "personal_relief",
    sorter: (a, b) => (a.personal_relief || 0) - (b.personal_relief || 0),
  },
  {
    title: "Insurance Relief",
    key: "InsuranceRelief",
    dataIndex: "insurance_relief",
    sorter: (a, b) => (a.insurance_relief || 0) - (b.insurance_relief || 0),
  },
  {
    title: "PAYE",
    key: "PAYE",
    dataIndex: "paye",
    sorter: (a, b) => (a.paye || 0) - (b.paye || 0),
  },
  {
    title: "Net Pay",
    key: "NetPay",
    dataIndex: "net_pay",
    sorter: (a, b) => (a.net_pay || 0) - (b.net_pay || 0),
  },
];

const moneyColumns = [
  "Gross",
  "Taxable",
  "TaxCharged",
  "PersonalRelief",
  "InsuranceRelief",
  "PAYE",
  "NetPay",
];

const dataSource = computed(() =>
  (props.rows || []).map((row, idx) => ({
    key: idx,
    ...row,
  })),
);
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 1120px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
